import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=5e3709f7&scoped=true"
import script from "./couponList.vue?vue&type=script&lang=js"
export * from "./couponList.vue?vue&type=script&lang=js"
import style0 from "./couponList.vue?vue&type=style&index=0&id=5e3709f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3709f7",
  null
  
)

export default component.exports